export default "__VITE_ASSET__c344ed83__"